import { take, put, select, call, fork } from 'redux-saga/effects';
import uuid from 'uuid/v4';

import { respawn } from 'yeself-client-common/utils/SagaUtils';
import log from 'yeself-client-common/utils/LogUtils';

import { pushNotificationToStack } from 'Console/data/notification/actions';

import {
    FETCH_APPLICATION_LIST,
    CREATE_NEW_APPLICATION,
    UPDATE_NOTIFICATION,
    FETCH_NOTIFICATION_LIST,
} from './constants';
import {
    fetchApplicationList,
    fetchApplicationListSuccess,
    fetchApplicationListError,
    crateNewApplicationError,
    fetchNotificationListSuccess,
    fetchNotificationListError,
    updateNotificationSuccess,
    updateNotificationError,
} from './actions';
import {
    fetchApplicationListService,
    createNewApplicationRequest,
    fetchNotificationsRequest,
    updateNotificationsRequest,
} from './services';

export function* fetchApplicationListTask() {
    try {
        const payload = yield call(fetchApplicationListService);

        const sortedData = payload.body.data.sort((a, b) => {
            const nameA = a.name.toLowerCase();
            const nameB = b.name.toLowerCase();
            if (nameA < nameB) {
                // sort string ascending
                return -1;
            }
            if (nameA > nameB) return 1;
            return 0; // default return value (no sorting)
        });

        yield put(fetchApplicationListSuccess(sortedData));
    } catch (err) {
        log.error(err);
        yield put(fetchApplicationListError());
    }
}

function* fetchApplicationListWatcher() {
    while (true) {
        yield take(FETCH_APPLICATION_LIST);
        yield fork(fetchApplicationListTask);
    }
}

function* createNewApplicationWatcher() {
    while (true) {
        const { payload, message } = yield take(CREATE_NEW_APPLICATION);
        const { name, domain, inviteEmails, organizationId } = payload;
        const domainWithoutScheme = domain.replace(/^https?:\/\//, '');

        try {
            const newApplicationData = {
                id: uuid(),
                name,
                active: true,
                originUrl: /^https?:\/\//.test(domain) ? domain : `https://${domain}`,
                trustedDomain: domainWithoutScheme,
                emails: inviteEmails,
                organizationId,
            };

            const resp = yield call(createNewApplicationRequest, newApplicationData);
            yield put(fetchApplicationList(resp.body));
            yield put(pushNotificationToStack(message.success));
        } catch (err) {
            log.error(err);
            yield put(crateNewApplicationError());
            yield put(pushNotificationToStack(message.fail));
        }
    }
}

function* updateNotificationWatcher() {
    while (true) {
        const {
            payload: { userId, notificationId, data },
        } = yield take(UPDATE_NOTIFICATION);

        try {
            const resp = yield call(updateNotificationsRequest, userId, notificationId, data);

            const updatedData = JSON.parse(resp.text);

            yield put(updateNotificationSuccess(notificationId, updatedData));
        } catch (err) {
            log.error(err);
            yield put(updateNotificationError(err));
        }
    }
}

function* fetchNotificationWatcher() {
    while (true) {
        const { payload } = yield take(FETCH_NOTIFICATION_LIST);
        try {
            const resp = yield call(fetchNotificationsRequest, payload);
            const data = JSON.parse(resp.text);
            yield put(fetchNotificationListSuccess(data.payload));
        } catch (err) {
            log.error(err);
            yield put(fetchNotificationListError());
        }
    }
}

export default function* applicationsSaga() {
    yield respawn(fetchApplicationListWatcher);
    yield respawn(createNewApplicationWatcher);
    yield respawn(updateNotificationWatcher);
    yield respawn(fetchNotificationWatcher);
}
